/**
 * Convert a Vue component to an object of default prop values
 * @param {Object} Component
 * @returns Object
 */
export const toPropObject = Component => {
    if (!Component.props) {
        return {};
    }

    return Object.keys(Component.props).reduce((acc, prop) => {
        acc[`${prop}`] = Component.props[`${prop}`].default;
        return acc;
    }, {});
};

/**
 * Import a component from path
 * @param {String,Object} component
 * @returns {Object}
 */
export const importComponent = async component => {
    if (typeof component === 'string' && component.startsWith('App')) {
        return () => import(`@/components/${component}.vue`);
    }

    if (typeof component === 'string' && component.startsWith('@')) {
        return () => import(`@/${component.substring(2)}.vue`);
    }

    return component;
};
